import api from "dao/providers/axios";
import appconfig from "config/appconfig";
import environment from 'lib/environment';

const apiBaseUrl = { baseURL: environment.get().api.castleServiceURL };
const passkeyRegistrationOptions = appconfig.endpoints.passkeyRegistrationOptions;
const passkeyRegistration = appconfig.endpoints.passkeyRegistration;
const passkeys = appconfig.endpoints.passkeys;
const passkeyByCredentialId = appconfig.endpoints.passkeyByCredentialId;


export const daoPasskeyRegistrationOptionsPost = (payload, authProp) => api.post(passkeyRegistrationOptions, payload, { ...apiBaseUrl, headers: { Authorization: `${authProp}` } });

export const daoPasskeyRegistrationPost = (payload, authProp) => api.post(passkeyRegistration, payload, { ...apiBaseUrl, headers: { Authorization: `${authProp}` } });

export const daoPasskeyGet = () => api.get(passkeys, apiBaseUrl);

export const daoPasskeyDelete = (credentialId, authProp) => api.delete(passkeyByCredentialId(credentialId), { ...apiBaseUrl, headers: { Authorization: `${authProp}` } });
